// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wg_a bhs_b"};